import { generateUpsellPageUrl, getUpsellOffers } from "../../../common/js/upsells"
import { TrackingManager } from "../../../common/js/services/tracking/trackingManager"

export default () => ({
  internalTracker: new TrackingManager(
    window.trackingConfig.enabledTrackingServices,
    pipelineConfig,
  ),

  init() {
    this.store = Alpine.store("data")

    // Save purchased basic offer, as active offer will be overwritten during upsells
    this.store.savePurchasedBasicOffer()

    const data = { segmentUserId: this.store.values.segmentUserId || "" }

    this.internalTracker.isUserIdentified(data).then((isIdentified) => {
      if (!isIdentified) {
        this.internalTracker.trackIdentify({
          customData: {
            email: this.store.values.email,
            segmentUserId: this.store.values.segmentUserId,
          },
        })
      }
    })
  },

  handleContinue() {
    this.internalTracker.trackClick({ clickName: "Continue Clicked" })

    this.proceed()
  },

  proceed() {
    const upsellOffers = getUpsellOffers(pipelineConfig.offers)

    // No upsells provided
    if (upsellOffers.length === 0) {
      this.store.goToLogin()
      return
    }

    // Proceed to upsells starting from the first defined by products
    const firstUpselll = upsellOffers[0]

    const firstUpsellOfferUrl = generateUpsellPageUrl({
      upsellOfferType: firstUpselll.type,
    })

    window.location = firstUpsellOfferUrl
  },
})
